var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGarden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "64px",
    height: "64px",
    viewBox: "0 0 250 250",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.948076,0,0,0.948076,13.1515,40.9163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.696,57.343L194.962,51.406C208.211,40.581 227.756,42.548 238.582,55.797C249.407,69.046 247.44,88.592 234.191,99.417L188.156,137.032L188.156,57.343L187.696,57.343Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "7.91px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.948076,0,0,0.948076,13.1515,40.9163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.696,57.343L194.962,51.406C208.211,40.581 227.756,42.548 238.582,55.797C249.407,69.046 247.44,88.592 234.191,99.417L188.156,137.032L188.156,57.343L187.696,57.343Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "7.91px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.522974,-0.640952,0.775495,0.632752,-22.7777,95.5201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.279,56.905L13.571,56.924L10.533,165.122L31.163,165.122L27.279,56.905Z",
    style: {
      fill: "#b97d6d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.166,171.302L95.907,160.326L121.571,180.028L110.782,193.25L28.464,122.84L32.994,117.269L96.166,171.302Z",
    style: {
      fill: "#b97d6d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.522974,-0.640952,0.775495,0.632752,-22.7777,95.5201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.279,56.905L13.571,56.924L10.533,165.122L31.163,165.122L27.279,56.905Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "8.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.619492,-0.717689,-0.717689,-0.619492,24.3021,172.356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.939,47.166L23.439,47.166L44.039,31.166L54.339,31.166L74.939,47.166Z",
    style: {
      fill: "#b97d6d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.545,105.794L35.597,114.051L29.216,121.443L4.972,126.315L12.077,118.083L25.216,115.443L33.545,105.794Z",
    style: {
      fill: "#b97d6d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.619492,-0.717689,-0.717689,-0.619492,24.3021,172.356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.939,47.166L23.439,47.166L44.039,31.166L54.339,31.166L74.939,47.166Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "7.91px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.948076,0,0,0.948076,13.1515,40.9163)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 115.035,
    style: {
      fill: "#b97d6d",
      stroke: "black",
      strokeWidth: "7.91px"
    },
    width: 91.259,
    x: 96.897,
    y: 57.343
  })), /*#__PURE__*/React.createElement("rect", {
    height: 109.062,
    style: {
      fill: "#b97d6d"
    },
    width: 22,
    x: 169.537,
    y: 95.281
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.948076,0,0,0.948076,13.1515,40.9163)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 115.035,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "7.91px"
    },
    width: 91.259,
    x: 96.897,
    y: 57.343
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.944147,0,0,1.2903,6.60097,32.4103)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 53,
    style: {
      fill: "#b97d6d",
      stroke: "black",
      strokeWidth: "6.63px"
    },
    width: 15.062,
    x: 142.526,
    y: 10.266
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.712261,0,0,0.948076,47.4737,2.51919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.897,197.878L187.156,197.878",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "8.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.712261,0,0,0.948076,47.4737,-63.8461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.897,197.878L187.156,197.878",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "8.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.712261,0,0,0.948076,47.4737,-51.5211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.897,197.878L187.156,197.878",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "8.94px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.0e8083b2e13918a3503640f652babb95.svg";
export { ForwardRef as ReactComponent };